// CHANGES TO THIS FILE MAY CAUSE INCORRECT BEHAVIOR AND WILL BE LOST IF THE CODE IS REGENERATED
// auto-generated on 7/12/2024 7:23:00 AM by John Caccavaro's (caccavaro123@gmail.com) Frameworks tool.

/* eslint-disable @typescript-eslint/no-empty-interface */

import { BankAccountPurposeFlagsEnum } from '../schema/Schema';
import { LocationTypeEnum } from '../../../appCore/models/schema/Schema';
import { LocationStatusTypeEnum } from '../../../appCore/models/schema/Schema';
import { CompanyTypeEnum } from '../../../appCore/models/schema/Schema';
import { CompanyStatusTypeEnum } from '../../../appCore/models/schema/Schema';
import { RemittanceFrequencyTypeEnum } from '../../../appCore/models/schema/Schema';
import { ValidationScopeTypeEnum } from '../../../appCore/models/schema/Schema';
import { AlfredCompanyStatusTypeEnum } from '../schema/Schema';
import { CountryTypeEnum } from '../../../appCore/models/schema/Schema';

export enum TimelineChangeTypeEnum {
  notDefined = 0,
  permanant = 1,
  temporary = 2,
}

export enum GetAccountVerificationDetails {
  companyIdIsRequired = 0,
}

export enum GetCompanyEnum {
  companyNotFound = 0,
  invalidCorrelationKey = 1,
  invalidFilter = 2,
}

export enum PersistCompanyEnum {
  invalidCompanyTypeId = 0,
  companyIsNull = 1,
  invalidCompany = 2,
  multiplePrimaryLocation = 3,
  cannotSignupNewCompany = 4,
}

export enum GetPartnerListEnum {
  invalidClientId = 0,
}

export enum PartnerStatusTypeEnum {
  inviteSent = 0,
  partnerRequestReceived = 1,
  accepted = 2,
  disconnected = 3,
  closed = 4,
}

export enum GetPartnerCompanyEnum {
  invalidClientId = 0,
}

export enum CompanySortTypeEnum {
  notDefined = 0,
  companyName = 1,
  country = 2,
  accountOwner = 3,
}

export enum GetCompanySummaryListEnum {}

export enum TaxNumberTypeEnum {
  taxProperty = 0,
  taxInfo = 1,
  wcbRate = 2,
}

export enum PersistLocationEnum {
  locationIsNull = 0,
  invalidLocation = 1,
  invalidCompanyId = 2,
  employeeCountNotZero = 3,
}

export enum PersistAssociatedCompanyEnum {
  companyNameNull = 0,
}

export enum GetCompanyForInvitationEnum {
  companyNotFound = 0,
  invalidFilter = 1,
  ownerEmailNotFound = 2,
}

export enum ExtendedCompanyStatusTypeEnum {
  notDefined = 0,
  waitingData = 1,
  pendingVerification = 2,
  active = 3,
  inActive = 4,
  closeInitiated = 5,
  closePending = 6,
  closed = 7,
  expired = 8,
  banned = 9,
  suspended = 10,
  inTrial = 11,
}

export interface ToggleAccountsRequestInterface {
  toggleRequestList: Array<ToggleRequestInterface>;
}

export interface ToggleAccountsResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface ToggleRequestInterface {
  id: number;
  isLocked: boolean;
  taxNumberType: TaxNumberTypeEnum;
}

export interface CompanySummaryInterface {
  clientId: number;
  partnerId?: number;
  invitationId?: number;
  name: string;
  logoId?: number;
  countryId: number;
  ownerName: string;
  companyCode: string;
  email: string;
  securityRoleTypeId: number;
  dateInvited: string;
  dateAccepted: string;
  assignedAdminCount: number;
  partnerStatusType: PartnerStatusTypeEnum;
  activePartnerCount: number;
  isPartnerHandling: boolean;
  partnerIsTheOnlySubmitter: boolean;
}

export interface ChangeCollectionMethodRequestInterface {
  companyId: number;
}

export interface ChangeCollectionMethodResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface GetOnBehalfCompanyListRequestInterface {}

export interface GetOnBehalfCompanyListResponseInterface {
  onBehalfCompanyList: Array<OnBehalfCompanyInterface>;
  validationResults: ValidationResultsInterface;
}

export interface OnBehalfCompanyInterface {
  id: number;
  companyName: string;
}

export interface TaxAgencyInterface {
  id: number;
  name: string;
}

export interface GetTaxAgencyListRequestInterface {}

export interface GetTaxAgencyListResponseInterface {
  taxAgencyList: Array<TaxAgencyInterface>;
  validationResults: ValidationResultsInterface;
}

export interface GetAccountVerificationDetailsRequestInterface {
  companyId: number;
  bankAccountPurposeType: BankAccountPurposeFlagsEnum;
}

export interface GetAccountVerificationDetailsResponseInterface {
  verification: VerificationInterface;
  validationResults: ValidationResultsInterface;
}

export interface VerificationInterface {
  id: number;
  bankAccountStatus: string;
  riskComplianceStatus: string;
  processingTimeline: number;
  currentYearNsfRecords: number;
  riskAssessmentLevelType: string;
  permantRiskType: string;
  watchlistReasonType: string;
  timelineChangeType: TimelineChangeTypeEnum;
  newProcessingDays: number;
  effectiveDate: string;
  payDateList: Array<PayDateInterface>;
}

export interface PayDateInterface {
  date: string;
}

export interface LocationInterface {
  id: number;
  address1: string;
  address2: string;
  city: string;
  state: string;
  country: string;
  postal: string;
  locationType: LocationTypeEnum;
  name: string;
  isPrimary: boolean;
  employeeCount: number;
  locationStatusType: LocationStatusTypeEnum;
  stateId?: number;
  countryId: number;
  phoneNumber: string;
  companyId: number;
  remoteEmployeeCount: number;
}

export interface CompanyInterface {
  id: number;
  companyType: CompanyTypeEnum;
  primaryContactId?: number;
  companyStatusType: CompanyStatusTypeEnum;
  accountExecutivePersonId?: number;
  name: string;
  dba: string;
  description: string;
  email: string;
  createdDate: string;
  updatedDate?: string;
  companyCode: string;
  logoId: number;
  craNumber: string;
  feinNumber: string;
  twoStepApproval: boolean;
  jurisdictionId?: number;
  registrationNumber: string;
  jurisdiction: string;
  defaultToClientsPayCharges: boolean;
  accountOwnerEmail: string;
  accountOwnerName: string;
  remittanceFrequencyType: RemittanceFrequencyTypeEnum;
  inSuspense: boolean;
  isTrial: boolean;
  hasPartnerEnforced2sa: boolean;
  isMigrated?: boolean;
  autoAssignAdmin?: boolean;
  locationList: Array<LocationInterface>;
}

export interface GetCompanyRequestInterface {
  id: number;
  getById: boolean;
  includeEmployeeCounts: boolean;
  getByCompanyCode: boolean;
  companyCode: string;
  getByEmail: boolean;
  email: string;
  getByName: boolean;
  companyName: string;
  getByOwnerEmail: boolean;
  ownerEmail: string;
  includeBlacklistCompanyPersonList: boolean;
}

export interface GetCompanyResponseInterface {
  showFraudAlert: boolean;
  company: CompanyInterface;
  blacklistCompanyPersonList: Array<BlacklistCompanyPersonInterface>;
  validationResults: ValidationResultsInterface;
}

export interface PersistCompanyRequestInterface {
  validationScopeType: ValidationScopeTypeEnum;
  company: CompanyInterface;
}

export interface PersistCompanyResponseInterface {
  companyStatusType: CompanyStatusTypeEnum;
  validationResults: ValidationResultsInterface;
}

export interface GetPartnerCompanyListRequestInterface {
  clientId: number;
  includeLinkedCompanies: boolean;
}

export interface GetPartnerCompanyListResponseInterface {
  companySummaryList: Array<CompanySummaryInterface>;
  validationResults: ValidationResultsInterface;
}

export interface GetPartnerCompanyRequestInterface {
  clientId: number;
  partnerId: number;
}

export interface GetPartnerCompanyResponseInterface {
  companySummary: CompanySummaryInterface;
  validationResults: ValidationResultsInterface;
}

export interface AlfredCompanySummaryInterface {
  id: number;
  name: string;
  dba: string;
  companyTypeFlags: number;
  companyCode: string;
  country: string;
  accountOwnerName: string;
  showFraudAlert: boolean;
  companyStatusType: CompanyStatusTypeEnum;
  alfredCompanyStatusType: AlfredCompanyStatusTypeEnum;
  accountOwnerEmail: string;
  inSuspense: boolean;
  isTrial: boolean;
  isMigrated: boolean;
  partnerCompanyList: Array<PartnerCompanyInterface>;
}

export interface GetCompanySummaryListRequestInterface {
  filterOnCompanyTypeFlags: boolean;
  filterOnAlfredCompanyStatus: boolean;
  filterOnCountry: boolean;
  filterOnMonthList: boolean;
  filterOnYearList: boolean;
  countryIdList?: Array<number>;
  monthList: Array<number>;
  yearList: Array<number>;
  companyTypeFlags: number;
  skip: number;
  take: number;
  sortDescending: boolean;
  searchString?: string;
  companySortType: CompanySortTypeEnum;
  includePartnerList: boolean;
  alfredCompanyStatusType: AlfredCompanyStatusTypeEnum;
  showOnlyTestCompanies: boolean;
  filterOnCompanyStatusType: boolean;
  companyStatusTypeList: ExtendedCompanyStatusTypeEnum[];
}

export interface GetCompanySummaryListResponseInterface {
  alfredCompanySummaryList: Array<AlfredCompanySummaryInterface>;
  validationResults: ValidationResultsInterface;
}

export interface PartnerCompanyInterface {
  id: number;
  name: string;
}

export interface BlacklistCompanyPersonInterface {
  firstName: string;
  lastName: string;
  email: string;
  associatedCompanies: Array<string>;
  id: number;
}

export interface PersistRequestInterface {
  validationScopeType: ValidationScopeTypeEnum;
  company: CompanyInterface;
}

export interface PersistResponseInterface {
  companyId: number;
  companyStatusType: CompanyStatusTypeEnum;
  validationResults: ValidationResultsInterface;
}

export interface PersistLocationRequestInterface {
  companyId: number;
  location: LocationInterface;
}

export interface PersistLocationResponseInterface {
  id: number;
  validationResults: ValidationResultsInterface;
}

export interface PersistAssociatedCompanyRequestInterface {
  companyName: string;
  country: CountryTypeEnum;
  craNumber: string;
  feinNumber: string;
}

export interface PersistAssociatedCompanyResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface GetCompanyForInvitationRequestInterface {
  getByCompanyCode: boolean;
  companyCode: string;
  getByEmail: boolean;
  email: string;
  getByName: boolean;
  companyName: string;
  getByOwnerEmail: boolean;
  ownerEmail: string;
  id: number;
  getById: boolean;
  getByCompanyTypeFlags: boolean;
  companyTypeFlags: number;
}

export interface GetCompanyForInvitationResponseInterface {
  companyLite: CompanyLiteInterface;
  validationResults: ValidationResultsInterface;
}

export interface CompanyLiteInterface {
  id: number;
  companyStatusType: CompanyStatusTypeEnum;
  companyCode: string;
  defaultToClientsPayCharges: boolean;
  name: string;
  isPartner: boolean;
}

export enum ValidationSeverityEnum {
  NotDefined = 0,
  Passed,
  Information,
  Warning,
  Error,
}

export interface ValidationResultInterface {
  validationSeverityEnum: ValidationSeverityEnum;
  validationMessage: string;
  exceptionInformation: string;
  validationCode: number;
  validationTag: string;
  isValid: boolean;
}

export interface ValidationResultsInterface {
  validationResultList?: Array<ValidationResultInterface>;
}

import { Post } from '../../../httpClient';

export class CompanyAccessService {
  toggleAccounts(request: ToggleAccountsRequestInterface): Promise<ToggleAccountsResponseInterface> {
    return Post('/FinanceCompanyAccess/toggleAccounts', request);
  }

  changeCollectionMethod(
    request: ChangeCollectionMethodRequestInterface
  ): Promise<ChangeCollectionMethodResponseInterface> {
    return Post('/FinanceCompanyAccess/changeCollectionMethod', request);
  }

  getOnBehalfCompanyList(
    request: GetOnBehalfCompanyListRequestInterface
  ): Promise<GetOnBehalfCompanyListResponseInterface> {
    return Post('/FinanceCompanyAccess/getOnBehalfCompanyList', request);
  }

  getTaxAgencyList(request: GetTaxAgencyListRequestInterface): Promise<GetTaxAgencyListResponseInterface> {
    return Post('/FinanceCompanyAccess/getTaxAgencyList', request);
  }

  getAccountVerificationDetails(
    request: GetAccountVerificationDetailsRequestInterface
  ): Promise<GetAccountVerificationDetailsResponseInterface> {
    return Post('/FinanceCompanyAccess/getAccountVerificationDetails', request);
  }

  getCompany(request: GetCompanyRequestInterface): Promise<GetCompanyResponseInterface> {
    return Post('/FinanceCompanyAccess/getCompany', request);
  }

  persistCompany(request: PersistCompanyRequestInterface): Promise<PersistCompanyResponseInterface> {
    return Post('/FinanceCompanyAccess/persistCompany', request);
  }

  getPartnerCompanyList(
    request: GetPartnerCompanyListRequestInterface
  ): Promise<GetPartnerCompanyListResponseInterface> {
    return Post('/FinanceCompanyAccess/getPartnerCompanyList', request);
  }

  getPartnerCompany(request: GetPartnerCompanyRequestInterface): Promise<GetPartnerCompanyResponseInterface> {
    return Post('/FinanceCompanyAccess/getPartnerCompany', request);
  }

  getCompanySummaryList(
    request: GetCompanySummaryListRequestInterface
  ): Promise<GetCompanySummaryListResponseInterface> {
    return Post('/FinanceCompanyAccess/getCompanySummaryList', request);
  }

  persist(request: PersistRequestInterface): Promise<PersistResponseInterface> {
    return Post('/FinanceCompanyAccess/persist', request);
  }

  persistLocation(request: PersistLocationRequestInterface): Promise<PersistLocationResponseInterface> {
    return Post('/FinanceCompanyAccess/persistLocation', request);
  }

  persistAssociatedCompany(
    request: PersistAssociatedCompanyRequestInterface
  ): Promise<PersistAssociatedCompanyResponseInterface> {
    return Post('/FinanceCompanyAccess/persistAssociatedCompany', request);
  }

  getCompanyForInvitation(
    request: GetCompanyForInvitationRequestInterface
  ): Promise<GetCompanyForInvitationResponseInterface> {
    return Post('/FinanceCompanyAccess/getCompanyForInvitation', request);
  }
}

export default new CompanyAccessService();
